
seedWebApp.controller('RemoveConfirmationCtrl', ['$scope', 'prefs', 'item', '$uibModalInstance', function ($scope, prefs, item, $uibModalInstance) {

    $scope.prefs = prefs;
    $scope.item = item;

    $scope.removeItem = function () {
        if ($scope.item) {
            if ($scope.prefs.removeItem) {
                $scope.prefs.removeItem($scope.item);
                $scope.ok();
            }
        }
    };

    $scope.ok = function () {
        $uibModalInstance.close('deleted');
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };


}]);
